import { on, createReducer } from '@ngrx/store';
import { getRateTypes, getRateTypesSuccess } from './rate-type.actions';
import { StoreState } from '../../enums/store-state';
import { Dropdown } from '../../models/dropdown';

export const rateTypeFeatureKey = 'rateTypeFeatureKey';

export interface RateTypeState {
  rateTypeState: StoreState;
  rateTypes: Dropdown[];
}

export const initialState: RateTypeState = {
  rateTypeState: StoreState.idle,
  rateTypes: []
};

export const rateTypeReducer = createReducer(
  initialState,

  on(getRateTypes, (state) => ({
    ...state,
    rateTypeState: StoreState.inProgress,
    rateTypes: []
  })),
  on(getRateTypesSuccess, (state, data) => ({
    ...state,
    rateTypeState: StoreState.success,
    rateTypes: data.rateTypes
  }))
);
